import "./style/index.scss";
import dayjs from "dayjs";
import { Card, Col, Collapse, Form, Row, Select, Table, Tag, Image, Badge, Button, Input, Tooltip, Flex } from "antd";
import { currencyBRL, formatNumber } from "../../util/dinheiroBRAuxiliar";
import { VendaConsignatarioModel } from "../../models/vendaConsignatario/vendaConsignatarioModel";
import { useAppSelector, useAppDispatch } from "../../util/hooks";
import UploadArquivosComponentConsig from "./components/uploadArquivosConsignatarioComponent";
import { ColumnsType } from "antd/es/table";
import { useEffect, useState } from "react";
import { setIdEmpresaPermissao, setTitle } from "../../redux/slices/configuracoes/configuracoesSlice";
import { buscarEmpresa } from "../../services/empresaService";
import { buscarAnexosVendaConsignatario, buscarVendaConsignatario } from "../../services/vendaConsignatarioService";
import { setEntityVendaConsignatario, setBuscaVendaConsignatario } from "../../redux/slices/vendaConsignatario/vendaConsignatarioSlice";
import { CustomHeader } from "../../util/anexoConsignatarioAuxiliar";
import { useLocation } from "react-router-dom";
import { listarAnexosPrestacaoContaConsignatario } from "../../services/prestacaoContaService";
import { formatCPFCNPJ } from "../../util/formats";
import * as Icon from "@ant-design/icons";
import { listarSorteio } from "../../services/sorteioService";
import { buscarConsignatario } from "../../services/consiganatarioService";
import { NumericFormat } from "react-number-format";
import { EmpresaModel } from "../../models/empresa/empresaModel";
import TableComponent from "../../components/table/tableComponent";
import { BuscarVendaConsignatarioModel } from "../../models/vendaConsignatario/buscarVendaConsignatarioModel";
import { SelectedRowKeysModel } from "../../models/sistema/selectedRowKeysModel";

const { Panel } = Collapse;

dayjs.locale("pt-br");

const PrestacaoConta = () => {
  //estados globais
  const persistedState = useAppSelector((state) => state.persisted);
  const empresaState = useAppSelector((state) => state.empresa);
  const sorteioState = useAppSelector((state) => state.sorteio);
  const vendaConsignatarioState = useAppSelector((state) => state.vendaConsignatario);
  const prestacaoContaState = useAppSelector((state) => state.prestacaoConta);
  const [selectedRowKeys, setSelectedRowKeys] = useState<SelectedRowKeysModel>({ keys: [], rows: [] } as SelectedRowKeysModel);

  //hooks
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();

  //estados locais
  const [form] = Form.useForm();
  const [collapseKey, setCollapseKey] = useState<string[]>(["4"]);

  const isClick = Object.values(vendaConsignatarioState.entity).length !== 0;

  const fetchConsignatario = async () => {
    const retornoConsignatario = await dispatch(
      buscarConsignatario({
        id: persistedState.user.idConsignatario,
        idUsuario: null,
        idEmpresa: persistedState.user.empresa && persistedState.user.empresa.idEmpresa,
        pesquisar: null,
        ativo: null,
      })
    );
    const retornoVenda = await dispatch(
      buscarVendaConsignatario({
        idSorteio: null,
        idEmpresa: persistedState.user.empresa && persistedState.user.empresa.idEmpresa,
        idConsignatario: persistedState.user.idConsignatario,
      })
    );
    form.setFieldsValue({ nomeConsignatario: retornoConsignatario.payload[0]?.apelido, saldo: currencyBRL(retornoVenda.payload[0]?.saldo) });
  };

  useEffect(() => {
    dispatch(buscarEmpresa(empresaState.busca));
    if (pathname === "/controleComprovanteConsignatario") {
      dispatch(setTitle("CONTROLE DE COMPROVANTES DOS CONSIGNATÁRIOS"));
      form.setFieldsValue({ idEmpresa: null, dataSorteio: null });
    } else {
      dispatch(setTitle("PRESTAÇÃO DE CONTAS"));
      fetchConsignatario();
    }
    if (isClick) {
      dispatch(listarAnexosPrestacaoContaConsignatario(vendaConsignatarioState.entity.id));
    }
    if (persistedState.user.empresa !== null) {
      dispatch(setIdEmpresaPermissao(persistedState.user.empresa.idEmpresa));
      form.setFieldsValue({ idEmpresa: persistedState.user.empresa.idEmpresa });
      onChangeEmpresa(persistedState.user.empresa.idEmpresa);
    }
  }, [pathname]);

  const selecionarLinha = (value: SelectedRowKeysModel) => {
    setSelectedRowKeys(value);
    dispatch(setEntityVendaConsignatario(value.rows[0]));
    setCollapseKey(["6"]);
    dispatch(listarAnexosPrestacaoContaConsignatario(value.rows[0].id));
    dispatch(
      buscarAnexosVendaConsignatario({
        idTipoArquivo: 4,
        idVendaConsignatario: value.rows[0].id,
      })
    );
  };

  const filtroNomeConsignatario = () =>
    Array.from(
      new Set<any>(
        vendaConsignatarioState.list.map((a: any) => ({
          text: a.nomeConsignatario,
          value: a.nomeConsignatario,
        }))
      )
    );

  const onChangeEmpresa = (value: number) => {
    dispatch(setIdEmpresaPermissao(value));

    var busca: BuscarVendaConsignatarioModel = { ...vendaConsignatarioState.busca, idEmpresa: value };

    form.resetFields(["idSorteio"]);

    dispatch(listarSorteio(value.toString()));
    dispatch(setBuscaVendaConsignatario(busca));
  };

  const onChangeSorteio = async (value: number) => {
    var busca = { ...vendaConsignatarioState.busca };
    busca.idSorteio = value;
    dispatch(setBuscaVendaConsignatario(busca));
  };

  const changePanel = async (key: string | string[]) => {
    setCollapseKey(key as string[]);
    await dispatch(
      buscarAnexosVendaConsignatario({
        idTipoArquivo: parseInt(key as string),
        idVendaConsignatario: vendaConsignatarioState.entity.id,
      })
    );
  };

  const carregarDados = async () => {
    dispatch(setEntityVendaConsignatario({}));
    dispatch(buscarVendaConsignatario(vendaConsignatarioState.busca));
  };

  const columnCaixa: ColumnsType<VendaConsignatarioModel> = [
    {
      title: "CONSIGNATÁRIO",
      dataIndex: "nomeConsignatario",
      align: "left",
      sorter: (a, b) => a.nomeConsignatario.localeCompare(b.nomeConsignatario),
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "CPF/CNPJ",
      dataIndex: "cpfCnpjConsignatario",
      align: "center",
      render: (_, record) => formatCPFCNPJ(record.cpfCnpjConsignatario),
    },
    {
      title: "VALOR TOTAL",
      dataIndex: "valorTotal",
      align: "right",
      render: (_, record) => currencyBRL(record.valorTotal),
    },
    {
      title: "SALDO",
      dataIndex: "saldo",
      align: "right",
      render: (_, record) => currencyBRL(record.saldo),
    },
    {
      title: "STATUS",
      dataIndex: "status",
      align: "center",
      filters: [
        {
          text: "CONCLUÍDO",
          value: "1" as any,
        },
        {
          text: "PENDENTE",
          value: "0" as any,
        },
      ],
      onFilter: (value: any, record: any) => record.status.toString().includes(value),
      render: (_, record) => <Badge color={record.status ? "#5E993C" : "#FAAD14"} className="badgeAnexo" />,
    },
  ];

  const columnConsignatario = [
    Table.EXPAND_COLUMN,
    {
      title: "DATA DO SORTEIO",
      dataIndex: "dataSorteio",
      align: "left",
      render: (_: any, record: any) => <>{dayjs(record.dataSorteio).format("DD/MM/YYYY")}</>,
    },
    {
      title: "QTD VENDAS",
      dataIndex: "quantidadeVenda",
      align: "center",
      render: (_: any, record: any) => (record.quantidadeVenda >= 0 ? formatNumber(record.quantidadeVenda) : 0),
    },
    {
      title: "VALOR TOTAL",
      dataIndex: "valorTotal",
      align: "center",
      render: (_: any, record: any) => currencyBRL(record.valorTotal),
    },
    {
      title: "SALDO",
      dataIndex: "saldo",
      align: "center",
      render: (_: any, record: any) => currencyBRL(record.saldo),
    },
    {
      title: "STATUS",
      dataIndex: "status",
      align: "center",
      render: (_: any, record: any) => <Tag color={record.status ? "#5E993C" : "#FAAD14"}>{record.status ? "CONCLUÍDO" : "PENDENTE"}</Tag>,
    },
  ];

  return (
    <Flex vertical>
      <Form layout="vertical" form={form} onFinish={carregarDados}>
        {pathname === "/controleComprovanteConsignatario" ? (
          <Row gutter={12} align="bottom">
            <Col span={24}>
              <Flex gap={12}>
                {persistedState.user.empresa === null && (
                  <Form.Item
                    label="Empresa"
                    name="idEmpresa"
                    rules={[
                      {
                        required: true,
                        message: "Campo obrigatório",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      optionFilterProp="labelSearch"
                      loading={empresaState.loading}
                      onChange={onChangeEmpresa}
                      style={{ width: 300 }}
                      options={empresaState.list.map((a: EmpresaModel) => ({
                        value: a.id,
                        key: a.apelido,
                        label: (
                          <Flex justify="flex-start" align="center" gap={8} style={{ padding: "1px 0px" }}>
                            <Flex style={{ lineHeight: "0px" }}>
                              {a.urlLogotipoPequeno && <Image width={25} height={25} style={{ lineHeight: "0px" }} src={a.urlLogotipoPequeno} preview={false} />}
                            </Flex>
                            {a.apelido}
                          </Flex>
                        ),
                        labelSearch: a.apelido,
                      }))}
                    />
                  </Form.Item>
                )}
                <Form.Item
                  label="Data do sorteio"
                  name="idSorteio"
                  rules={[
                    {
                      required: true,
                      message: "Campo obrigatório",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    loading={sorteioState.loadingEmpresas}
                    onChange={onChangeSorteio}
                    style={{ width: 150 }}
                    defaultValue={vendaConsignatarioState.busca.idSorteio}
                    optionLabelProp="label"
                    options={sorteioState.listSorteioEmpresas.map((a: any) => ({
                      value: a.idSorteio,
                      label: dayjs(a.dataSorteio).format("DD/MM/YYYY"),
                    }))}
                  />
                </Form.Item>
                <Form.Item label=" ">
                  <Button className="addButton buttonPrimary" icon={<Icon.PlusCircleOutlined />} htmlType="submit">
                    CARREGAR DADOS
                  </Button>
                </Form.Item>
                <Form.Item label=" ">
                  <Tooltip title="Atualizar">
                    <Button icon={<Icon.RedoOutlined />} className="buttonPrimary" onClick={carregarDados} />
                  </Tooltip>
                </Form.Item>
              </Flex>
            </Col>
          </Row>
        ) : (
          <Row gutter={12} align="bottom">
            <Col span={24}>
              <Flex gap={12}>
                <Form.Item label="Consignatário" name="nomeConsignatario">
                  <Input type="text" disabled />
                </Form.Item>
                <Form.Item label="Saldo" name="saldo">
                  <NumericFormat
                    style={{ width: "100%" }}
                    className="ant-input noBoderColor number-input"
                    thousandSeparator="."
                    decimalSeparator=","
                    decimalScale={2}
                    prefix="R$"
                    disabled
                    fixedDecimalScale={true}
                  />
                </Form.Item>
              </Flex>
            </Col>
          </Row>
        )}
      </Form>
      <Row gutter={12} align="top">
        <Col span={12}>
          <Card className="cardAnexoLista">
            <TableComponent
              columns={pathname === "/controleComprovanteConsignatario" ? columnCaixa : columnConsignatario}
              data={vendaConsignatarioState.list}
              loading={vendaConsignatarioState.loading}
              selectionType="radio-allowed"
              rowSelection={selecionarLinha}
              tableProps={{
                className: pathname === "/prestacaoConta" ? "tableListaConsig" : "tableListaCompro",
                title: () => {
                  return <>{pathname !== "/controleComprovanteConsignatario" ? "ÚLTIMOS SORTEIOS" : ""}</>;
                },
                onRow: (record: VendaConsignatarioModel) => {
                  return {
                    onClick: () => {
                      selecionarLinha({ keys: [record.id], rows: [record] });
                    },
                  };
                },
                selectedRowKeys: selectedRowKeys.keys,
              }}
            />
          </Card>
        </Col>
        {isClick && (
          <Col span={12} style={pathname !== "/controleComprovanteConsignatario" ? { marginTop: "46px" } : { marginTop: "0px" }}>
            <Card className="cardAnexoLista">
              <p className="titlePrestacao" style={pathname === "/controleComprovanteConsignatario" ? { height: "36px" } : { height: "41px" }}>
                DOCUMENTOS SOLICITADOS ({dayjs(vendaConsignatarioState.entity.dataSorteio).format("DD/MM/YYYY")})
              </p>
              <Collapse accordion activeKey={collapseKey} onChange={changePanel} ghost className="collapsePrestacao">
                <Panel header={<CustomHeader listaAnexo={prestacaoContaState.transferencia} texto="Comprovante de transferência" valor={vendaConsignatarioState.entity.valorTotal * 0.8} />} key="6">
                  <UploadArquivosComponentConsig valor={vendaConsignatarioState.entity.valorTotal * 0.8} entity={vendaConsignatarioState.entity} idTipoArquivoAnexo={6} />
                </Panel>
              </Collapse>
            </Card>
          </Col>
        )}
      </Row>
    </Flex>
  );
};

export default PrestacaoConta;
